import React from 'react';

import Hero from '../components/hero';
import Form from '../components/contact-form';
import Laptop from '../components/laptop-cta';

const ContactTemplate = () => {
	return (
		<div>
			<Hero
				img="/img/Contact_Masthead.svg"
				mobileImg="/img/contact-mobile.svg"
				alt="Megaphone illustration"
				title="Contact Us"
				className="contact"
				subtext="Looking for more info or to donate or host an event? Contact us here!"
			/>
			<Form />
			<Laptop img="/img/ComputerWoman2.svg" />
		</div>
	);
};

export default ContactTemplate;
